import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotVideos from './components/HotVideos';
import LatestVideos from './components/LatestVideos';
import FeaturedCollections from './components/FeaturedCollections';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotVideos />
        <LatestVideos />
        <FeaturedCollections />
      </main>
      <Footer />
    </>
  );
}